import { render, staticRenderFns } from "./pendaftaran_saksi.vue?vue&type=template&id=583d910c&"
import script from "./pendaftaran_saksi.vue?vue&type=script&lang=js&"
export * from "./pendaftaran_saksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports